import { Box, TextNew } from '@jfs/ui-new'
import { DomesticMoneyTransferStrings } from '../Strings'
import { styles } from './styles'

interface TransactionIdInterface {
  transactionId: string
}

export const TransactionId = ({ transactionId }: TransactionIdInterface) => {
  if (transactionId?.length < 1) {
    return null
  }
  return (
    <Box>
      <Box {...styles.tickContainer}>
        <TextNew {...styles.transactionId} title={DomesticMoneyTransferStrings.transactionId} />
      </Box>
      <Box {...styles.transactionIdContainer}>
        <TextNew {...styles.fundTransferredText} title={transactionId} />
      </Box>
    </Box>
  )
}
